// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-settings .settings-container {
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 0;
  display: flex;
  overflow: hidden;
}

.server-settings .settings-sidebar {
  width: 240px;
  background-color: #2b2d31;
  overflow-y: auto !important;
  max-height: 100vh;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.server-settings .settings-sidebar::-webkit-scrollbar {
  width: 6px;
  display: block;
}

.server-settings .settings-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.server-settings .settings-sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.server-settings .settings-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}

.server-settings .settings-main {
  background-color: #313338;
  flex: 1;
  height: 100%;
  overflow-y: auto;
}

.server-profile-edit {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.server-identity-grid {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.identity-item {
  flex: 1;
}

.identity-item label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #b5bac1;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.identity-item .desc {
  color: var(--text-muted);
  font-size: 14px;
  margin-bottom: 16px;
}

.identity-actions {
  display: flex;
  gap: 12px;
}

.btn-brand {
  background-color: var(--brand-primary);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.btn-ghost {
  background: transparent;
  color: white;
  border: none;
  font-size: 14px;
  cursor: pointer;
}

.identity-preview {
  width: 300px;
}

.preview-card {
  background-color: #111214;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.3);
}

.preview-banner-mock {
  height: 60px;
  background: linear-gradient(to bottom, #2b2d31, #111214);
}

.preview-content-mock {
  padding: 16px;
  position: relative;
}

.preview-avatar-mock {
  width: 64px;
  height: 64px;
  background: var(--brand-primary);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 800;
  color: white;
  border: 4px solid #111214;
  margin-top: -48px;
}

.preview-info-mock {
  margin-top: 12px;
}

.preview-name {
  font-size: 16px;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
}

.preview-stats {
  font-size: 12px;
  color: #b5bac1;
  display: flex;
  align-items: center;
  gap: 6px;
}

.stat-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.stat-dot.green { background-color: #23a559; }
.stat-dot.gray { background-color: #80848e; }

.preview-date {
  margin-top: 8px;
  font-size: 11px;
  color: var(--text-muted);
}

.banner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.banner-option {
  height: 44px;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid transparent;
}

.banner-option:hover {
  border-color: white;
}

.color-1 { background: linear-gradient(45deg, #000, #333); }
.color-2 { background: linear-gradient(45deg, #ff0080, #ff8c00); }
.color-3 { background: linear-gradient(45deg, #ff0000, #8b0000); }
.color-4 { background: linear-gradient(45deg, #ffa500, #ffd700); }
.color-5 { background: linear-gradient(45deg, #ffff00, #ffea00); }
.color-6 { background: linear-gradient(45deg, #8a2be2, #4b0082); }
.color-7 { background: linear-gradient(45deg, #00bfff, #1e90ff); }
.color-8 { background: linear-gradient(45deg, #00fa9a, #00ced1); }
.color-9 { background: linear-gradient(45deg, #32cd32, #228b22); }
.color-10 { background: linear-gradient(45deg, #555, #222); }

.save-notice {
  position: fixed;
  bottom: 20px;
  left: 240px;
  right: 20px;
  background-color: #111214;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.5);
  z-index: 100;
}

.save-notice span {
  color: white;
  font-weight: 600;
}

.save-actions {
  display: flex;
  gap: 16px;
}

.reset-btn {
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
}

.save-btn {
  background-color: #23a559;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 8px 16px;
  font-weight: 600;
  cursor: pointer;
}

.save-btn:hover { background-color: #1a7f44; }
.save-btn:disabled { opacity: 0.5; }

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: var(--text-muted);
  gap: 20px;
}

.empty-state p {
  font-size: 18px;
  font-weight: 600;
}

/* Premium Styles added for Server Settings Profile Overview */
.server-profile-edit .input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.server-profile-edit .input-group label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #b5bac1;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.server-profile-edit .input-group input {
  width: 100%;
  background-color: #1e1f22 !important;
  border: 1px solid rgba(0, 0, 0, 0.4) !important;
  border-radius: 4px !important;
  padding: 10px 14px !important;
  color: #dbdee1 !important;
  font-size: 15px !important;
  outline: none !important;
  transition: border-color 0.2s !important;
}

.server-profile-edit .input-group input:focus {
  border-color: var(--brand-primary) !important;
}

.preview-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.banner-option.active {
  border-color: white !important;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8) !important;
}

/* ── SETTINGS TABS UI ── */

.settings-section h2 {
  font-size: 20px;
  font-weight: 700;
  color: #f2f3f5;
  margin-bottom: 8px;
}

.settings-section .section-desc {
  font-size: 14px;
  color: #b5bac1;
  margin-bottom: 24px;
}

/* Members List */
.members-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.member-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #2b2d31;
  border-radius: 8px;
  border: 1px solid #1e1f22;
}

.member-info-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.member-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #1e1f22;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #dbdee1;
}

.member-details .member-name {
  font-weight: 600;
  color: #f2f3f5;
  font-size: 15px;
}

.member-details .member-date {
  font-size: 12px;
  color: #949ba4;
  margin-top: 2px;
}

.member-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.member-role-badge {
  background-color: #1e1f22;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #b5bac1;
  font-weight: 600;
}

.action-btn-danger {
  background: transparent;
  color: #949ba4;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.action-btn-danger:hover {
  color: #da373c;
  background-color: rgba(218, 55, 60, 0.1);
}

/* Roles List */
.roles-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.role-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #2b2d31;
  border-radius: 8px;
  border-left: 4px solid #80848e;
}

.role-item.admin { border-left-color: #ed4245; }
.role-item.mod { border-left-color: #5865f2; }

.role-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.role-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #80848e;
}
.role-dot.admin { background-color: #ed4245; }
.role-dot.mod { background-color: #5865f2; }

.role-name {
  font-weight: 600;
  color: #f2f3f5;
}

.role-count {
  font-size: 12px;
  color: #b5bac1;
  font-weight: 500;
}

/* Invites */
.invite-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.invite-item {
  padding: 16px;
  background-color: #2b2d31;
  border-radius: 8px;
}

.invite-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.invite-code {
  font-family: monospace;
  font-size: 16px;
  color: var(--brand-primary);
  font-weight: 600;
}

.invite-creator {
  font-size: 12px;
  color: #949ba4;
  margin-top: 4px;
}

.invite-meta {
  font-size: 12px;
  color: #80848e;
}

/* Safety Options */
.safety-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.safety-card {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #1e1f22;
  background-color: #2b2d31;
  cursor: pointer;
  transition: 0.2s;
}

.safety-card:hover {
  border-color: #4e5058;
}

.safety-card.active {
  border-color: var(--brand-primary);
  background-color: rgba(235, 69, 158, 0.05);
}

.safety-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 15px;
  color: #f2f3f5;
  margin-bottom: 4px;
}

.safety-card-desc {
  font-size: 14px;
  color: #b5bac1;
}

/* Advanced Audit List */
.audit-header-flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 24px;
}

.audit-filters {
  display: flex;
  gap: 16px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-group label {
  font-size: 12px;
  font-weight: 700;
  color: #b5bac1;
  text-transform: none;
}

.filter-select {
  background-color: #1e1f22;
  border: 1px solid rgba(0,0,0,0.3);
  color: #dbdee1;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  min-width: 180px;
  outline: none;
  cursor: pointer;
}

.audit-advanced-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.audit-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #2b2d31;
  border: 1px solid #1e1f22;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.1s;
}

.audit-card:hover {
  background-color: #313338;
}

.audit-card-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.audit-action-icon-wrapper {
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #949ba4;
}

.audit-type-icon .badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: white;
  border: 2px solid #2b2d31;
}

.audit-type-icon .badge.red { background-color: #da373c; }
.audit-type-icon .badge.green { background-color: #23a559; }
.audit-type-icon .badge.blue { background-color: #5865f2; }

.audit-user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.audit-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.audit-text {
  font-size: 14px;
  color: #b5bac1;
}

.audit-text .text-gray-200 {
  color: #dbdee1;
}

.audit-time {
  font-size: 12px;
  color: #949ba4;
}

.audit-arrow {
  color: #80848e;
  font-weight: bold;
  font-family: monospace;
}

/* Empty Bans */
.empty-state-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  background-color: #2b2d31;
  border-radius: 8px;
  text-align: center;
}

.empty-state-icon {
  color: #80848e;
  margin-bottom: 16px;
}

.empty-state-card h3 {
  color: #f2f3f5;
  font-size: 18px;
  margin-bottom: 8px;
}

.empty-state-card p {
  color: #b5bac1;
  font-size: 14px;
}

/* ===========================
   DISCORD-STYLE ROLE MANAGER
   =========================== */
.roles-discord-layout {
  display: flex;
  height: 100%;
  gap: 0;
  overflow: hidden;
}

/* Left panel */
.roles-left-panel {
  width: 220px;
  min-width: 220px;
  background: rgba(0,0,0,0.15);
  border-right: 1px solid rgba(255,255,255,0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.roles-left-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 12px 8px;
  font-size: 11px;
  font-weight: 700;
  color: #80848e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.roles-add-btn {
  background: rgba(255,255,255,0.08);
  border: none;
  color: #b5bac1;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
}

.roles-add-btn:hover {
  background: var(--accent);
  color: #fff;
}

.roles-left-list {
  flex: 1;
  overflow-y: auto;
  padding: 4px 0 8px;
}

.roles-left-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  border: none;
  background: transparent;
  color: #b5bac1;
  cursor: pointer;
  border-radius: 6px;
  margin: 1px 4px;
  width: calc(100% - 8px);
  text-align: left;
  font-size: 14px;
  transition: background 0.1s, color 0.1s;
}

.roles-left-item:hover {
  background: rgba(255,255,255,0.06);
  color: #e0e1e5;
}

.roles-left-item.active {
  background: rgba(var(--accent-rgb, 114, 137, 218), 0.2);
  color: #fff;
}

.role-dot-sm {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.role-list-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.role-default-badge {
  font-size: 10px;
  background: rgba(255,255,255,0.1);
  border-radius: 4px;
  padding: 1px 5px;
  color: #80848e;
}

.role-arrow {
  color: #4e5058;
  font-size: 18px;
  line-height: 1;
}

/* Right panel */
.roles-right-panel {
  flex: 1;
  overflow-y: auto;
  padding: 24px 28px;
}

.role-editor {
  max-width: 540px;
}

.role-editor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}

.role-editor-header h2 {
  font-size: 20px;
  font-weight: 700;
  color: #f2f3f5;
  margin: 0;
}

.role-editor-close {
  background: none;
  border: none;
  color: #80848e;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.15s, background 0.15s;
}

.role-editor-close:hover {
  color: #f2f3f5;
  background: rgba(255,255,255,0.08);
}

.role-delete-btn {
  background: none;
  border: none;
  color: #80848e;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: color 0.15s, background 0.15s;
}

.role-delete-btn:hover {
  color: #ed4245;
  background: rgba(237,66,69,0.15);
}

.role-delete-confirm {
  background: rgba(237,66,69,0.1);
  border: 1px solid rgba(237,66,69,0.35);
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 20px;
}

.role-delete-confirm p {
  color: #f2f3f5;
  font-size: 14px;
  margin: 0 0 12px;
}

.role-dot-lg {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.role-field {
  margin-bottom: 24px;
}

.role-field > label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #b5bac1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.role-input {
  width: 100%;
  background: rgba(0,0,0,0.25);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 6px;
  padding: 10px 12px;
  color: #f2f3f5;
  font-size: 15px;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}

.role-input:focus {
  border-color: var(--accent, #5865f2);
}

.role-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.role-color-picker {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.role-color-preview {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  flex-shrink: 0;
  cursor: pointer;
  position: relative;
  border: 2px solid rgba(255,255,255,0.15);
  transition: transform 0.15s;
}

.role-color-preview:hover {
  transform: scale(1.08);
}

.role-color-input-hidden {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.role-color-presets {
  display: grid;
  grid-template-columns: repeat(10, 24px);
  gap: 6px;
}

.role-preset-color {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  transition: transform 0.12s, border-color 0.12s;
  padding: 0;
}

.role-preset-color:hover {
  transform: scale(1.2);
}

.role-preset-color.selected {
  border-color: #fff;
  transform: scale(1.15);
}

.role-editor-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid rgba(255,255,255,0.06);
  margin-top: 8px;
}

/* Empty state */
.roles-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 300px;
  color: #4e5058;
  text-align: center;
  gap: 16px;
}

.roles-empty-state p {
  color: #6d6f78;
  font-size: 15px;
  max-width: 300px;
  line-height: 1.6;
}

.roles-link-btn {
  background: none;
  border: none;
  color: var(--accent, #5865f2);
  cursor: pointer;
  font-size: 15px;
  padding: 0;
  text-decoration: underline;
}

.roles-link-btn:hover {
  opacity: 0.8;
}

/* Override settings-main padding for roles tab */
.server-settings .settings-main.roles-fullheight {
  padding: 0 !important;
  overflow: hidden !important;
}

/* Role Editor Tabs */
.role-tabs {
  display: flex;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  margin-bottom: 24px;
}

.role-tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #b5bac1;
  font-size: 14px;
  font-weight: 500;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 8px;
}

.role-tab:hover {
  color: #e0e1e5;
  border-bottom-color: rgba(255,255,255,0.2);
}

.role-tab.active {
  color: #f2f3f5;
  border-bottom-color: var(--accent, #5865f2);
}

/* Permissions Tab */
.permissions-header {
  margin-bottom: 24px;
}

.permissions-header h3 {
  color: #f2f3f5;
  font-size: 16px;
  margin: 0 0 4px;
}

.permissions-header p {
  color: #b5bac1;
  font-size: 13px;
  margin: 0;
}

.permission-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid rgba(255,255,255,0.04);
}

.permission-info h4 {
  color: #f2f3f5;
  font-size: 15px;
  font-weight: 500;
  margin: 0 0 4px;
}

.permission-info p {
  color: #80848e;
  font-size: 13px;
  margin: 0;
  max-width: 400px;
}

/* Toggle Switch */
.permission-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  flex-shrink: 0;
}

.permission-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.permission-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #80848e;
  transition: .4s;
  border-radius: 24px;
}

.permission-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.permission-switch input:checked + .permission-slider {
  background-color: #23a559;
}

.permission-switch input:focus + .permission-slider {
  box-shadow: 0 0 1px #23a559;
}

.permission-switch input:checked + .permission-slider:before {
  transform: translateX(16px);
}

/* Members Tab */
.role-members-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.role-member-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: rgba(255,255,255,0.03);
  border-radius: 6px;
  transition: background 0.2s;
}

.role-member-item:hover {
  background: rgba(255,255,255,0.05);
}

.role-member-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.role-member-info img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.role-member-info span {
  color: #f2f3f5;
  font-weight: 500;
  font-size: 14px;
}

.role-member-remove {
  background: none;
  border: none;
  color: #80848e;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.role-member-remove:hover {
  color: #ed4245;
  background: rgba(237,66,69,0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Settings/ServerSettings.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB,yBAAyB,EAAE;AAC7C,iBAAiB,yBAAyB,EAAE;;AAE5C;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW,8CAA8C,EAAE;AAC3D,WAAW,oDAAoD,EAAE;AACjE,WAAW,oDAAoD,EAAE;AACjE,WAAW,oDAAoD,EAAE;AACjE,WAAW,oDAAoD,EAAE;AACjE,WAAW,oDAAoD,EAAE;AACjE,WAAW,oDAAoD,EAAE;AACjE,WAAW,oDAAoD,EAAE;AACjE,WAAW,oDAAoD,EAAE;AACjE,YAAY,8CAA8C,EAAE;;AAE5D;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB,yBAAyB,EAAE;AAC7C,qBAAqB,YAAY,EAAE;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,+CAA+C;EAC/C,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA,2BAA2B;;AAE3B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,mBAAmB,0BAA0B,EAAE;AAC/C,iBAAiB,0BAA0B,EAAE;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA,kBAAkB,yBAAyB,EAAE;AAC7C,gBAAgB,yBAAyB,EAAE;;AAE3C;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,8BAA8B,yBAAyB,EAAE;AACzD,gCAAgC,yBAAyB,EAAE;AAC3D,+BAA+B,yBAAyB,EAAE;;AAE1D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;gCAEgC;AAChC;EACE,aAAa;EACb,YAAY;EACZ,MAAM;EACN,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC","sourcesContent":[".server-settings .settings-container {\n  max-width: 100%;\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  display: flex;\n  overflow: hidden;\n}\n\n.server-settings .settings-sidebar {\n  width: 240px;\n  background-color: #2b2d31;\n  overflow-y: auto !important;\n  max-height: 100vh;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n}\n\n.server-settings .settings-sidebar::-webkit-scrollbar {\n  width: 6px;\n  display: block;\n}\n\n.server-settings .settings-sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.server-settings .settings-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n}\n\n.server-settings .settings-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.server-settings .settings-main {\n  background-color: #313338;\n  flex: 1;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.server-profile-edit {\n  margin-top: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.server-identity-grid {\n  display: flex;\n  gap: 40px;\n  align-items: flex-start;\n}\n\n.identity-item {\n  flex: 1;\n}\n\n.identity-item label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: #b5bac1;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.identity-item .desc {\n  color: var(--text-muted);\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.identity-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-brand {\n  background-color: var(--brand-primary);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-ghost {\n  background: transparent;\n  color: white;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.identity-preview {\n  width: 300px;\n}\n\n.preview-card {\n  background-color: #111214;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.3);\n}\n\n.preview-banner-mock {\n  height: 60px;\n  background: linear-gradient(to bottom, #2b2d31, #111214);\n}\n\n.preview-content-mock {\n  padding: 16px;\n  position: relative;\n}\n\n.preview-avatar-mock {\n  width: 64px;\n  height: 64px;\n  background: var(--brand-primary);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 800;\n  color: white;\n  border: 4px solid #111214;\n  margin-top: -48px;\n}\n\n.preview-info-mock {\n  margin-top: 12px;\n}\n\n.preview-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 4px;\n}\n\n.preview-stats {\n  font-size: 12px;\n  color: #b5bac1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.stat-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.stat-dot.green { background-color: #23a559; }\n.stat-dot.gray { background-color: #80848e; }\n\n.preview-date {\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.banner-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.banner-option {\n  height: 44px;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 2px solid transparent;\n}\n\n.banner-option:hover {\n  border-color: white;\n}\n\n.color-1 { background: linear-gradient(45deg, #000, #333); }\n.color-2 { background: linear-gradient(45deg, #ff0080, #ff8c00); }\n.color-3 { background: linear-gradient(45deg, #ff0000, #8b0000); }\n.color-4 { background: linear-gradient(45deg, #ffa500, #ffd700); }\n.color-5 { background: linear-gradient(45deg, #ffff00, #ffea00); }\n.color-6 { background: linear-gradient(45deg, #8a2be2, #4b0082); }\n.color-7 { background: linear-gradient(45deg, #00bfff, #1e90ff); }\n.color-8 { background: linear-gradient(45deg, #00fa9a, #00ced1); }\n.color-9 { background: linear-gradient(45deg, #32cd32, #228b22); }\n.color-10 { background: linear-gradient(45deg, #555, #222); }\n\n.save-notice {\n  position: fixed;\n  bottom: 20px;\n  left: 240px;\n  right: 20px;\n  background-color: #111214;\n  padding: 12px 20px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 -4px 20px rgba(0,0,0,0.5);\n  z-index: 100;\n}\n\n.save-notice span {\n  color: white;\n  font-weight: 600;\n}\n\n.save-actions {\n  display: flex;\n  gap: 16px;\n}\n\n.reset-btn {\n  background: transparent;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n\n.save-btn {\n  background-color: #23a559;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  padding: 8px 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.save-btn:hover { background-color: #1a7f44; }\n.save-btn:disabled { opacity: 0.5; }\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n  color: var(--text-muted);\n  gap: 20px;\n}\n\n.empty-state p {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n/* Premium Styles added for Server Settings Profile Overview */\n.server-profile-edit .input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.server-profile-edit .input-group label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: #b5bac1;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.server-profile-edit .input-group input {\n  width: 100%;\n  background-color: #1e1f22 !important;\n  border: 1px solid rgba(0, 0, 0, 0.4) !important;\n  border-radius: 4px !important;\n  padding: 10px 14px !important;\n  color: #dbdee1 !important;\n  font-size: 15px !important;\n  outline: none !important;\n  transition: border-color 0.2s !important;\n}\n\n.server-profile-edit .input-group input:focus {\n  border-color: var(--brand-primary) !important;\n}\n\n.preview-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n}\n\n.banner-option.active {\n  border-color: white !important;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8) !important;\n}\n\n/* ── SETTINGS TABS UI ── */\n\n.settings-section h2 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #f2f3f5;\n  margin-bottom: 8px;\n}\n\n.settings-section .section-desc {\n  font-size: 14px;\n  color: #b5bac1;\n  margin-bottom: 24px;\n}\n\n/* Members List */\n.members-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.member-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background-color: #2b2d31;\n  border-radius: 8px;\n  border: 1px solid #1e1f22;\n}\n\n.member-info-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.member-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #1e1f22;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: #dbdee1;\n}\n\n.member-details .member-name {\n  font-weight: 600;\n  color: #f2f3f5;\n  font-size: 15px;\n}\n\n.member-details .member-date {\n  font-size: 12px;\n  color: #949ba4;\n  margin-top: 2px;\n}\n\n.member-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.member-role-badge {\n  background-color: #1e1f22;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #b5bac1;\n  font-weight: 600;\n}\n\n.action-btn-danger {\n  background: transparent;\n  color: #949ba4;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.2s;\n}\n\n.action-btn-danger:hover {\n  color: #da373c;\n  background-color: rgba(218, 55, 60, 0.1);\n}\n\n/* Roles List */\n.roles-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.role-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background-color: #2b2d31;\n  border-radius: 8px;\n  border-left: 4px solid #80848e;\n}\n\n.role-item.admin { border-left-color: #ed4245; }\n.role-item.mod { border-left-color: #5865f2; }\n\n.role-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.role-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #80848e;\n}\n.role-dot.admin { background-color: #ed4245; }\n.role-dot.mod { background-color: #5865f2; }\n\n.role-name {\n  font-weight: 600;\n  color: #f2f3f5;\n}\n\n.role-count {\n  font-size: 12px;\n  color: #b5bac1;\n  font-weight: 500;\n}\n\n/* Invites */\n.invite-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.invite-item {\n  padding: 16px;\n  background-color: #2b2d31;\n  border-radius: 8px;\n}\n\n.invite-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.invite-code {\n  font-family: monospace;\n  font-size: 16px;\n  color: var(--brand-primary);\n  font-weight: 600;\n}\n\n.invite-creator {\n  font-size: 12px;\n  color: #949ba4;\n  margin-top: 4px;\n}\n\n.invite-meta {\n  font-size: 12px;\n  color: #80848e;\n}\n\n/* Safety Options */\n.safety-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.safety-card {\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #1e1f22;\n  background-color: #2b2d31;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.safety-card:hover {\n  border-color: #4e5058;\n}\n\n.safety-card.active {\n  border-color: var(--brand-primary);\n  background-color: rgba(235, 69, 158, 0.05);\n}\n\n.safety-card-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 15px;\n  color: #f2f3f5;\n  margin-bottom: 4px;\n}\n\n.safety-card-desc {\n  font-size: 14px;\n  color: #b5bac1;\n}\n\n/* Advanced Audit List */\n.audit-header-flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 24px;\n}\n\n.audit-filters {\n  display: flex;\n  gap: 16px;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filter-group label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #b5bac1;\n  text-transform: none;\n}\n\n.filter-select {\n  background-color: #1e1f22;\n  border: 1px solid rgba(0,0,0,0.3);\n  color: #dbdee1;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  min-width: 180px;\n  outline: none;\n  cursor: pointer;\n}\n\n.audit-advanced-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.audit-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #2b2d31;\n  border: 1px solid #1e1f22;\n  border-radius: 8px;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background-color 0.1s;\n}\n\n.audit-card:hover {\n  background-color: #313338;\n}\n\n.audit-card-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.audit-action-icon-wrapper {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #949ba4;\n}\n\n.audit-type-icon .badge {\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: bold;\n  color: white;\n  border: 2px solid #2b2d31;\n}\n\n.audit-type-icon .badge.red { background-color: #da373c; }\n.audit-type-icon .badge.green { background-color: #23a559; }\n.audit-type-icon .badge.blue { background-color: #5865f2; }\n\n.audit-user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n}\n\n.audit-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.audit-text {\n  font-size: 14px;\n  color: #b5bac1;\n}\n\n.audit-text .text-gray-200 {\n  color: #dbdee1;\n}\n\n.audit-time {\n  font-size: 12px;\n  color: #949ba4;\n}\n\n.audit-arrow {\n  color: #80848e;\n  font-weight: bold;\n  font-family: monospace;\n}\n\n/* Empty Bans */\n.empty-state-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  background-color: #2b2d31;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.empty-state-icon {\n  color: #80848e;\n  margin-bottom: 16px;\n}\n\n.empty-state-card h3 {\n  color: #f2f3f5;\n  font-size: 18px;\n  margin-bottom: 8px;\n}\n\n.empty-state-card p {\n  color: #b5bac1;\n  font-size: 14px;\n}\n\n/* ===========================\n   DISCORD-STYLE ROLE MANAGER\n   =========================== */\n.roles-discord-layout {\n  display: flex;\n  height: 100%;\n  gap: 0;\n  overflow: hidden;\n}\n\n/* Left panel */\n.roles-left-panel {\n  width: 220px;\n  min-width: 220px;\n  background: rgba(0,0,0,0.15);\n  border-right: 1px solid rgba(255,255,255,0.05);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.roles-left-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 12px 8px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #80848e;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.roles-add-btn {\n  background: rgba(255,255,255,0.08);\n  border: none;\n  color: #b5bac1;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, color 0.15s;\n}\n\n.roles-add-btn:hover {\n  background: var(--accent);\n  color: #fff;\n}\n\n.roles-left-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 0 8px;\n}\n\n.roles-left-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 8px 10px;\n  border: none;\n  background: transparent;\n  color: #b5bac1;\n  cursor: pointer;\n  border-radius: 6px;\n  margin: 1px 4px;\n  width: calc(100% - 8px);\n  text-align: left;\n  font-size: 14px;\n  transition: background 0.1s, color 0.1s;\n}\n\n.roles-left-item:hover {\n  background: rgba(255,255,255,0.06);\n  color: #e0e1e5;\n}\n\n.roles-left-item.active {\n  background: rgba(var(--accent-rgb, 114, 137, 218), 0.2);\n  color: #fff;\n}\n\n.role-dot-sm {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.role-list-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.role-default-badge {\n  font-size: 10px;\n  background: rgba(255,255,255,0.1);\n  border-radius: 4px;\n  padding: 1px 5px;\n  color: #80848e;\n}\n\n.role-arrow {\n  color: #4e5058;\n  font-size: 18px;\n  line-height: 1;\n}\n\n/* Right panel */\n.roles-right-panel {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 28px;\n}\n\n.role-editor {\n  max-width: 540px;\n}\n\n.role-editor-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 28px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n}\n\n.role-editor-header h2 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #f2f3f5;\n  margin: 0;\n}\n\n.role-editor-close {\n  background: none;\n  border: none;\n  color: #80848e;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: color 0.15s, background 0.15s;\n}\n\n.role-editor-close:hover {\n  color: #f2f3f5;\n  background: rgba(255,255,255,0.08);\n}\n\n.role-delete-btn {\n  background: none;\n  border: none;\n  color: #80848e;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  transition: color 0.15s, background 0.15s;\n}\n\n.role-delete-btn:hover {\n  color: #ed4245;\n  background: rgba(237,66,69,0.15);\n}\n\n.role-delete-confirm {\n  background: rgba(237,66,69,0.1);\n  border: 1px solid rgba(237,66,69,0.35);\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-bottom: 20px;\n}\n\n.role-delete-confirm p {\n  color: #f2f3f5;\n  font-size: 14px;\n  margin: 0 0 12px;\n}\n\n.role-dot-lg {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.role-field {\n  margin-bottom: 24px;\n}\n\n.role-field > label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  color: #b5bac1;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.role-input {\n  width: 100%;\n  background: rgba(0,0,0,0.25);\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 6px;\n  padding: 10px 12px;\n  color: #f2f3f5;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n\n.role-input:focus {\n  border-color: var(--accent, #5865f2);\n}\n\n.role-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.role-color-picker {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.role-color-preview {\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  cursor: pointer;\n  position: relative;\n  border: 2px solid rgba(255,255,255,0.15);\n  transition: transform 0.15s;\n}\n\n.role-color-preview:hover {\n  transform: scale(1.08);\n}\n\n.role-color-input-hidden {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n}\n\n.role-color-presets {\n  display: grid;\n  grid-template-columns: repeat(10, 24px);\n  gap: 6px;\n}\n\n.role-preset-color {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: transform 0.12s, border-color 0.12s;\n  padding: 0;\n}\n\n.role-preset-color:hover {\n  transform: scale(1.2);\n}\n\n.role-preset-color.selected {\n  border-color: #fff;\n  transform: scale(1.15);\n}\n\n.role-editor-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255,255,255,0.06);\n  margin-top: 8px;\n}\n\n/* Empty state */\n.roles-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 300px;\n  color: #4e5058;\n  text-align: center;\n  gap: 16px;\n}\n\n.roles-empty-state p {\n  color: #6d6f78;\n  font-size: 15px;\n  max-width: 300px;\n  line-height: 1.6;\n}\n\n.roles-link-btn {\n  background: none;\n  border: none;\n  color: var(--accent, #5865f2);\n  cursor: pointer;\n  font-size: 15px;\n  padding: 0;\n  text-decoration: underline;\n}\n\n.roles-link-btn:hover {\n  opacity: 0.8;\n}\n\n/* Override settings-main padding for roles tab */\n.server-settings .settings-main.roles-fullheight {\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n/* Role Editor Tabs */\n.role-tabs {\n  display: flex;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n  margin-bottom: 24px;\n}\n\n.role-tab {\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: #b5bac1;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-right: 8px;\n}\n\n.role-tab:hover {\n  color: #e0e1e5;\n  border-bottom-color: rgba(255,255,255,0.2);\n}\n\n.role-tab.active {\n  color: #f2f3f5;\n  border-bottom-color: var(--accent, #5865f2);\n}\n\n/* Permissions Tab */\n.permissions-header {\n  margin-bottom: 24px;\n}\n\n.permissions-header h3 {\n  color: #f2f3f5;\n  font-size: 16px;\n  margin: 0 0 4px;\n}\n\n.permissions-header p {\n  color: #b5bac1;\n  font-size: 13px;\n  margin: 0;\n}\n\n.permission-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n}\n\n.permission-info h4 {\n  color: #f2f3f5;\n  font-size: 15px;\n  font-weight: 500;\n  margin: 0 0 4px;\n}\n\n.permission-info p {\n  color: #80848e;\n  font-size: 13px;\n  margin: 0;\n  max-width: 400px;\n}\n\n/* Toggle Switch */\n.permission-switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.permission-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.permission-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #80848e;\n  transition: .4s;\n  border-radius: 24px;\n}\n\n.permission-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.permission-switch input:checked + .permission-slider {\n  background-color: #23a559;\n}\n\n.permission-switch input:focus + .permission-slider {\n  box-shadow: 0 0 1px #23a559;\n}\n\n.permission-switch input:checked + .permission-slider:before {\n  transform: translateX(16px);\n}\n\n/* Members Tab */\n.role-members-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.role-member-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: rgba(255,255,255,0.03);\n  border-radius: 6px;\n  transition: background 0.2s;\n}\n\n.role-member-item:hover {\n  background: rgba(255,255,255,0.05);\n}\n\n.role-member-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.role-member-info img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n}\n\n.role-member-info span {\n  color: #f2f3f5;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.role-member-remove {\n  background: none;\n  border: none;\n  color: #80848e;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.role-member-remove:hover {\n  color: #ed4245;\n  background: rgba(237,66,69,0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
